import DataTable from 'components/datatable';
import Error from 'components/Error';
import Spinner from 'components/Spinner';
import WizardActions from 'components/WizardActions';
import PropTypes from 'prop-types';
import React from 'react';
import Search from '../search';

class Applicants extends React.Component {
  updateApplicantFilters = (applicantFilters) => {
    const newApplicantFilters = Object.assign(this.state.filters, applicantFilters);
    this.setState({filters: newApplicantFilters});
  };

  highlightLessons = (lessons) => {
    this.setState({highlight: lessons});
  };
  
  setApplicantSelected = (isSelected) => {
    this.setState({applicantSelected: isSelected});
  };

  constructor(props) {
    super(props);

    this.state = {
      highlight: {},
      applicantSelected: false
    };

  }

  render() {
    const {
      error,
      applicants,
      loadingApplicants,
      loadingSaving,
      searchType,
      previousFn,
      nextFn,
      searchApplicants,
      nextDisabled,
      searchTerms,
      updateApplicantSearchTerms,
      currentCourse,
    } = this.props;

    const payloadApplicantId = !!applicants ? applicants.filter(a => a.selected).map(appl => appl.entityId)[0] : null;

    if (this.props.placeHolderSearchTerms) {
      this.props.updateApplicantSearchTerms({courseUnit: this.props.unitPlaceholder});
    }

    return (
      <div>
        <Search searchType={searchType}
                updateSearchTerms={updateApplicantSearchTerms}
                searchTerms={searchTerms}
                searchFn={searchApplicants} />
        {loadingApplicants && !error && <Spinner />}
        {error && !loadingApplicants && <Error message={error.message} />}

        {!!applicants && !loadingApplicants && !error &&
        <DataTable tableType='DRIVING_APPLICANTS' rows={applicants} rowKey='trafiId'
          highlightFn={this.highlightLessons}
          currentCourse={currentCourse}
          setApplicantSelectedFn={this.setApplicantSelected} />
        }
        <WizardActions
          nextText='action.next'
          nextFn={() => nextFn({applicantId: payloadApplicantId})}
          loading={loadingSaving}
          previousFn={previousFn}
          nextDisabled={nextDisabled}
        />
      </div>
    );
  }
}


Applicants.propTypes = {
  applicants: PropTypes.array,
  nextFn: PropTypes.func,
  previousFn: PropTypes.func,
  error: PropTypes.object,
  filters: PropTypes.object,
  loading: PropTypes.bool,
  loadingSaving: PropTypes.bool,
  searchType: PropTypes.string,
  searchApplicants: PropTypes.func,
  searchTerms: PropTypes.object,
  updateApplicantSearchTerms: PropTypes.func,
  placeHolderSearchTerms: PropTypes.bool,
  currentCourse: PropTypes.object,
};

export default Applicants;


// WEBPACK FOOTER //
// ./src/containers/driving/Applicants.jsx